/**
 * Browser and Device Detection
 * Adds specific classes to the <html> element to allow for browser/device-specific CSS.
 */
(function() {
  const ua = navigator.userAgent;
  const doc = document.documentElement;
  const platform = navigator.platform;
  const classes = [];

  // 1. Browser Detection
  const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || ua.indexOf(' OPR/') >= 0;
  const isFirefox = typeof InstallTrigger !== 'undefined';
  const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object HTMLElementSafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  const isEdge = !isIE && !!window.StyleMedia;
  const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  const isEdgeChromium = isChrome && (ua.indexOf("Edg") != -1);

  if (isOpera) classes.push('is-opera');
  if (isFirefox) classes.push('is-firefox');
  if (isSafari) classes.push('is-safari');
  if (isIE) classes.push('is-ie');
  if (isEdge) classes.push('is-edge');
  if (isEdgeChromium) classes.push('is-edge-chromium');
  if (isChrome && !isEdgeChromium) classes.push('is-chrome');

  // 2. OS Detection
  const isWindows = platform.indexOf('Win') !== -1;
  const isMac = platform.indexOf('Mac') !== -1;
  const isLinux = platform.indexOf('Linux') !== -1;
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (isMac && navigator.maxTouchPoints > 0); // Detect iPadOS as iOS

  if (isWindows) classes.push('is-windows');
  if (isMac && !isIOS) classes.push('is-macos');
  if (isLinux && !isAndroid) classes.push('is-linux');
  if (isAndroid) classes.push('is-android');
  if (isIOS) classes.push('is-ios');

  // Apply classes to <html>
  doc.classList.add(...classes);
})();
